const $ = jQuery.noConflict();

export default class CalendarMap {
    constructor() {
        this.mapWrapper = $('.map-informations');
        this.mapElement = this.mapWrapper.find('.map-itself');
    }

    init() {
        if (!this.mapWrapper.length) {
            return;
        }
        this.renderMap();
    }

    renderMap() {
        new google.maps.Map(this.mapElement[0], {
            zoom: 16,
            center: new google.maps.LatLng(this.mapElement.data('lat'), this.mapElement.data('lng')),
            styles: [{'featureType': 'water', 'elementType': 'all', 'stylers': [{'color': '#221A43'}]}, {'featureType': 'landscape', 'elementType': 'all', 'stylers': [{'color': '#181230'}]}, {'featureType': 'poi', 'elementType': 'all', 'stylers': [{'color': '#16102e'}]}, {'featureType': 'road', 'elementType': 'geometry.stroke', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'road', 'elementType': 'geometry.fill', 'stylers': [{'color': '#2c2354'}]}, {'featureType': 'administrative', 'elementType': 'labels.text.stroke', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'administrative', 'elementType': 'labels.text.fill', 'stylers': [{'visibility': 'on'}, {'color': '#6c629e'}]}, {'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{'color': '#5a4d94'}]}, {'featureType': 'administrative', 'elementType': 'labels.icon', 'stylers': [{'visibility': 'off'}, {'weight': 0.1}, {'hue': '#000000'}]}, {'featureType': 'road', 'elementType': 'geometry.fill', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'administrative.province', 'elementType': 'geometry.stroke', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'road', 'elementType': 'labels', 'stylers': [{'visibility': 'off'}]}],
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        });
    }
}
